export const CONTENT_FORMATS = ["markdown", "summary", "links", "html", "raw_html"] as const;
export type ContentFormat = typeof CONTENT_FORMATS[number];
